export const CLAIM_STATUS = {
  NEW: "new",
  PENDING: "pending",
  APPROVED: "approved",
  CLOSED: "closed",
  DENIED: "denied",
} as const;

export const RESOLUTION_TYPE = {
  REFUND: "refund",
  STORE_CREDIT: "store_credit",
  RESHIP: "reship",
  DEFAULT: "default",
} as const;

export const TRACKING_BASE_URL = "https://tracking.shipinsure.io/tracking";

export const CARE_EMAIL = "care@shipinsure.io";
